import { Trans } from 'react-i18next';
import { withError, withFieldError } from 'utils/old-ui-commons/final-form-states';

import { Checkbox, Input, InputPassword, Text } from '@olist/united';

export const CheckboxWith = withError(withFieldError(Checkbox));
export const InputWith = withError(withFieldError(Input));
export const PasswordWith = withError(withFieldError(InputPassword));

export const IncorrectCin = () => (
  <Trans i18nKey="<0>invalid cin, check if you already have an <2>olist account</2> or <2>contact us</2></0>">
    <Text>
      invalid cin, check if you already have an{' '}
      <Text.Link href="/login/" target="_blank">
        olist account
      </Text.Link>{' '}
      or{' '}
      <Text.Link
        onClick={() => {
          window.OlistSupport?.open();
        }}
      >
        contact us
      </Text.Link>
    </Text>
  </Trans>
);
